import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../utils/axiosAdvanced';

// API returns HTTP 200 for errors; check res.data.error
const normalizeError = (res) => {
    if (!res) return { error: 'No response' };
    if (res?.data?.error) return { error: res.data.error, meta: res.data };
    return null;
};

export const fetchAllDieselPrices = createAsyncThunk(
    'dieselPrice/fetchAll',
    async (_, thunkAPI) => {
        try {
            const res = await apiClient.post('/get_diesel_price', { type: 'all' });
            const err = normalizeError(res);
            if (err) return thunkAPI.rejectWithValue(err);
            return res.data?.data || null;
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error?.message || 'Request failed' });
        }
    }
);

export const fetchStateDieselPrices = createAsyncThunk(
    'dieselPrice/fetchState',
    async (stateInput, thunkAPI) => {
        try {
            const res = await apiClient.post('/get_diesel_price', { type: 'state', state: stateInput });
            const err = normalizeError(res);
            if (err) return thunkAPI.rejectWithValue(err);
            return res.data?.data || null; // { state, cities }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error?.message || 'Request failed' });
        }
    }
);

export const fetchCityDieselPrice = createAsyncThunk(
    'dieselPrice/fetchCity',
    async ({ state: stateInput, city }, thunkAPI) => {
        try {
            const res = await apiClient.post('/get_diesel_price', { type: 'city', state: stateInput, city });
            const err = normalizeError(res);
            if (err) return thunkAPI.rejectWithValue(err);
            return res.data?.data || null; // { state, city, price, change, scraped_at, data_source }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error?.message || 'Request failed' });
        }
    }
);
